import { gql } from 'graphql-tag';

import {
  AddressInfoFragment,
  LocationInfoFragment,
  MachineInfoFragment,
  SkuInfoFragment,
} from '@/graphql/fragments';

export const LOCATIONS = gql`
  ${AddressInfoFragment}
  ${SkuInfoFragment}
  ${MachineInfoFragment}
  ${LocationInfoFragment}

  query locations {
    locations {
      ...LocationInfo
      machines {
        ...MachineInfo
      }
      skus {
        ...SkuInfo
      }
      address {
        ...AddressInfo
      }
    }
  }
`;
